export const boundariesVeryProfitOriented = [
  [5000, 5000],
  [4699, 5366],
  [4591, 5539],
  [4514, 5682],
  [4454, 5808],
  [4403, 5925],
  [4360, 6036],
  [4322, 6141],
  [4288, 6243],
  [4258, 6341],
  [4230, 6437],
  [4205, 6531],
  [4182, 6624],
  [4160, 6715],
  [4141, 6805],
  [4122, 6894],
  [4105, 6982],
  [4089, 7070],
  [4074, 7156],
  [4060, 7243],
  [4047, 7329],
  [4035, 7414],
  [4023, 7499],
  [4012, 7584],
  [4002, 7669],
  [3992, 7754],
  [3983, 7839],
  [3974, 7923],
  [3966, 8007],
  [3958, 8092],
  [3951, 8176],
  [3944, 8261],
  [3938, 8346],
  [3932, 8430],
  [3926, 8515],
  [3921, 8600],
  [3915, 8685],
  [3911, 8770],
  [3906, 8856],
  [3902, 8941],
  [3898, 9027],
  [3894, 9113],
  [3891, 9199],
  [3888, 9286],
  [3885, 9373],
  [3882, 9460],
  [3880, 9547],
  [3877, 9635],
  [3875, 9723],
  [3873, 9811],
  [3872, 9900],
  [3870, 9989],
  [3869, 10078],
  [3867, 10168],
  [3866, 10258],
  [3866, 10348],
  [3865, 10439],
  [3864, 10530],
  [3864, 10621],
  [3864, 10713],
  [3863, 10806],
  [3863, 10898],
  [3864, 10991],
  [3864, 11085],
  [3864, 11179],
  [3865, 11273],
  [3866, 11368],
  [3866, 11463],
  [3867, 11559],
  [3868, 11655],
  [3869, 11752],
  [3871, 11849],
  [3872, 11946],
  [3873, 12044],
  [3875, 12143],
  [3877, 12242],
  [3878, 12341],
  [3880, 12441],
  [3882, 12542],
  [3884, 12643],
  [3886, 12744],
  [3889, 12846],
  [3891, 12949],
  [3893, 13052],
  [3896, 13155],
  [3898, 13259],
  [3901, 13364],
  [3904, 13469],
  [3907, 13575],
  [3910, 13681],
  [3913, 13788],
  [3916, 13896],
  [3919, 14004],
  [3922, 14112],
  [3925, 14221],
  [3929, 14331],
  [3932, 14442],
  [3936, 14553],
  [3939, 14664],
  [3943, 14776],
  [3947, 14889],
  [3950, 15002],
  [3954, 15116],
  [3958, 15231],
  [3962, 15346],
  [3966, 15462],
  [3970, 15578],
  [3975, 15695],
  [3979, 15813],
  [3983, 15932],
  [3987, 16051],
  [3992, 16170],
  [3996, 16291],
  [4001, 16412],
  [4006, 16533],
  [4010, 16656],
  [4015, 16779],
  [4020, 16903],
  [4025, 17027],
  [4030, 17152],
  [4035, 17278],
];

export const developmentVeryProfitOriented = [
  5000, 5026, 5051, 5077, 5103, 5129, 5155, 5181, 5208, 5234, 5261, 5288, 5315, 5342,
  5369, 5396, 5424, 5452, 5479, 5507, 5536, 5564, 5592, 5621, 5649, 5678, 5707, 5736,
  5765, 5795, 5824, 5854, 5884, 5914, 5944, 5974, 6005, 6036, 6066, 6097, 6128, 6160,
  6191, 6223, 6254, 6286, 6318, 6351, 6383, 6416, 6448, 6481, 6514, 6547, 6581, 6614,
  6648, 6682, 6716, 6750, 6785, 6819, 6854, 6889, 6924, 6960, 6995, 7031, 7067, 7103,
  7139, 7175, 7212, 7249, 7286, 7323, 7360, 7398, 7435, 7473, 7511, 7550, 7588, 7627,
  7666, 7705, 7744, 7784, 7823, 7863, 7904, 7944, 7984, 8025, 8066, 8107, 8148, 8190,
  8232, 8274, 8316, 8358, 8401, 8444, 8487, 8530, 8574, 8617, 8661, 8706, 8750, 8795,
  8839, 8885, 8930, 8975, 9021, 9067, 9113, 9160, 9207,
];

export const fluctuationVeryProfitOriented = [
  5000, 4971, 4937, 4933, 5100, 5584, 5612, 5598, 5700, 6037, 6020, 5499, 5315, 5601,
  6040, 6254, 6438, 6721, 6900, 6901, 6669, 6584, 6312, 6020, 5649, 5192, 5159, 5532,
  5753, 6020, 6167, 6311, 6174, 6217, 6510, 6312, 6005, 5747, 5824, 5710, 5527, 5383,
  5176, 5089, 5089, 5171, 5439, 5874, 6383, 6524, 6456, 6558, 6908, 6772, 7040, 7568,
  7987, 7718, 7120, 6891, 6785, 6571, 6379, 6770, 6979, 6981, 6818, 6359, 6194, 6525,
  6631, 7197, 7212, 6582, 6270, 6627, 6899, 6891, 7157, 7316, 7144, 7380, 7290, 7209,
  7666, 7979, 8334, 8510, 8709, 8623, 8196, 7575, 7663, 7837, 8509, 8508, 8148, 7800,
  7655, 7729, 7654, 7132, 7037, 7695, 8162, 8558, 8421, 8489, 8661, 8552, 8327, 8325,
  8156, 7712, 7744, 8300, 9040, 9644, 9607, 9421, 9207,
];
